<template>
  <div class="testimoni">
    <div class="testi row mt-8">
      <div class="col mt-9">
        <h2 class="txt-apa">
          Apa kata mereka <br />
          tentang Intelligo?
        </h2>
      </div>
      <div class="col mt-9">
        <p class="txt-testi">
          Testimoni dari mereka yang <br />
          sudah mengikuti bootcamp dengan kami
        </p>
        <h6 class="txt-view">View All</h6>
      </div>
    </div>

    <Splide
      :has-track="false"
      :options="{ rewind: true, perPage: 3, gap: '1em' }"
      aria-label="My Favorite Images"
    >
      <div class="container">
        <SplideTrack>
          <SplideSlide>
            <div class="card border-light">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <img class="pic1" src="../assets/pic1.png" alt="" />
                  </div>
                  <div class="card-name col">
                    <h5 class="card-title">Daniel Haryanto</h5>
                    <h6 class="card-subtitle mb-2 text-muted">
                      Universitas Indonesia
                    </h6>
                  </div>
                  <div class="card-rating col">
                    <h6>4.5</h6>
                  </div>
                  <div class="card-start col">
                    <img class="star" src="../assets/star.png" alt="" />
                  </div>
                </div>
                <p class="card-text">
                  “Lorem ipsum dolor sit amet. Ea natus vitae <br />
                  eos optio accusantium id quia odit aut <br />
                  molestias Quis. Ut dolores reiciendis ”
                </p>
              </div>
            </div>
          </SplideSlide>
          <SplideSlide>
            <div class="card border-light">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <img class="pic1" src="../assets/pic1.png" alt="" />
                  </div>
                  <div class="card-name col">
                    <h5 class="card-title">Daniel Haryanto</h5>
                    <h6 class="card-subtitle mb-2 text-muted">
                      Universitas Indonesia
                    </h6>
                  </div>
                  <div class="card-rating col">
                    <h6>4.5</h6>
                  </div>
                  <div class="card-start col">
                    <img class="star" src="../assets/star.png" alt="" />
                  </div>
                </div>
                <p class="card-text">
                  “Lorem ipsum dolor sit amet. Ea natus vitae <br />
                  eos optio accusantium id quia odit aut <br />
                  molestias Quis. Ut dolores reiciendis ”
                </p>
              </div>
            </div>
          </SplideSlide>
          <SplideSlide>
            <div class="card border-light">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <img class="pic1" src="../assets/pic1.png" alt="" />
                  </div>
                  <div class="card-name col">
                    <h5 class="card-title">Daniel Haryanto</h5>
                    <h6 class="card-subtitle mb-2 text-muted">
                      Universitas Indonesia
                    </h6>
                  </div>
                  <div class="card-rating col">
                    <h6>4.5</h6>
                  </div>
                  <div class="card-start col">
                    <img class="star" src="../assets/star.png" alt="" />
                  </div>
                </div>
                <p class="card-text">
                  “Lorem ipsum dolor sit amet. Ea natus vitae <br />
                  eos optio accusantium id quia odit aut <br />
                  molestias Quis. Ut dolores reiciendis ”
                </p>
              </div>
            </div>
          </SplideSlide>
          <SplideSlide>
            <div class="card border-light">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <img class="pic1" src="../assets/pic2.png" alt="" />
                  </div>
                  <div class="card-name col">
                    <h5 class="card-title">Eki Yulianto</h5>
                    <h6 class="card-subtitle mb-2 text-muted">
                      Front End Developer
                    </h6>
                  </div>
                  <div class="card-rating col">
                    <h6>5.0</h6>
                  </div>
                  <div class="card-start col">
                    <img class="star" src="../assets/star.png" alt="" />
                  </div>
                </div>
                <p class="card-text">
                  “Lorem ipsum dolor sit amet. Ea natus vitae <br />
                  eos optio accusantium id quia odit aut <br />
                  molestias Quis. Ut dolores reiciendis ”
                </p>
              </div>
            </div>
          </SplideSlide>
          <SplideSlide>
            <div class="card border-light">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <img class="pic1" src="../assets/pic2.png" alt="" />
                  </div>
                  <div class="card-name col">
                    <h5 class="card-title">Eki Yulianto</h5>
                    <h6 class="card-subtitle mb-2 text-muted">
                      Front End Developer
                    </h6>
                  </div>
                  <div class="card-rating col">
                    <h6>5.0</h6>
                  </div>
                  <div class="card-start col">
                    <img class="star" src="../assets/star.png" alt="" />
                  </div>
                </div>
                <p class="card-text">
                  “Lorem ipsum dolor sit amet. Ea natus vitae <br />
                  eos optio accusantium id quia odit aut <br />
                  molestias Quis. Ut dolores reiciendis ”
                </p>
              </div>
            </div>
          </SplideSlide>
        </SplideTrack>
        <div class="wrapper__splide">
          <div class="splide__pagination" />

          <div class="splide__arrows">
            <button class="splide__arrow splide__arrow--prev">
              <i class="fa-solid fa-circle-arrow-right"></i>
            </button>
            <button class="splide__arrow splide__arrow--next">
              <i class="fa-solid fa-circle-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </Splide>
  </div>
</template>

<script>
import { Splide, SplideSlide, SplideTrack } from "@splidejs/vue-splide";
export default {
  name: `TestiComp`,
  components: {
    Splide,
    SplideSlide,
    SplideTrack,
  },
};
</script>

<style scoped>
.testimoni {
  height: 650px;
  background: #faf9f9;
  margin-top: 170px;
  margin-bottom: 200px;
}
.testi {
  margin-left: 116px;
  margin-right: 116px;
  margin-bottom: 80px;
}
.txt-apa {
  margin-top: 130px;
  font-weight: 600;
  font-size: 35px;
  color: #050810;
}
.txt-testi {
  margin-top: 130px;
  text-align: right;
  font-weight: 400;
  font-size: 18px;
  color: #848484;
}
.txt-view {
  margin-left: 467px;
  margin-top: -5px;
  font-weight: 600;
  font-size: 16px;
  color: #f94f25;
}
.isi-card {
  margin-left: 116px;
  margin-right: 116px;
}
.card {
  border-radius: 16px;
}
.card-body {
  width: 400px;
  height: 180px;
}
.card-title {
  font-weight: 600;
  font-size: 17px;
  color: #050810;
  width: 179px;
}
.card-subtitle {
  font-weight: 400;
  font-size: 13px;
  color: #848484;
  width: 149px;
}
.card-start {
  margin-left: -70px;
  margin-top: 9px;
}
.card-rating {
  margin-left: 5px;
  margin-top: 15px;
  font-weight: 500;
  font-size: 15px;
  color: #050810;
}
.card-name {
  margin-top: 5px;
  margin-left: -35px;
}
.card-text {
  margin-top: 18px;
  font-weight: 400;
  font-size: 15px;
  color: #050810;
}
.star {
  width: 24px;
}
.pic1 {
  width: 52px;
  border-radius: 100%;
}
.link-page {
  margin-left: 116px;
  margin-bottom: 100px;
}
.page1 {
  width: 30px;
  height: 10px;
  background: #f94f25;
  border-radius: 100px;
  margin-left: 3px;
}
.page {
  width: 10px;
  height: 10px;
  margin-left: 3px;
}
.wrapper__splide {
  height: 2em;
  display: flex;
  justify-content: space-between;
  margin-top: 1em;
}
.splide__arrows {
  position: relative;
  display: flex;
  gap: 0.875em;
}
.splide__arrow {
  position: static !important;
  transform: translateY(0) !important;
}
.splide__arrow--next {
  color: white;
  background-color: #f94f25 !important ;
}
.splide__arrow--prev {
  color: #f94f25;
  background-color: #fedcd3 !important ;
}
.splide__pagination {
  position: static !important;
  justify-content: start !important;
}
.splide__pagination__page.is-active {
  background-color: #f94f25 !important;
  transform: scaleX(1.5) !important;
}
.splide__pagination__page {
  background-color: #fcab97 !important;
}

@media only screen and (max-width: 770px) {
  .testi {
    margin-left: 116px;
    margin-right: 116px;
    margin-bottom: 80px;
  }
  .txt-apa {
    margin-top: 100px;
    font-size: 30px;
  }
  .txt-testi {
    margin-top: 70px;
    text-align: left;
    font-size: 16px;
  }
  .txt-view {
    margin-left: 400px;
  }
}

@media only screen and (max-width: 610px) {
  .txt-apa , .txt-testi {
    margin-left: -20%;
  }
  .txt-view {
    width: 100px;
    margin-left: 300px;
  }
}

@media only screen and (max-width: 550px) {
  .testimoni {
    margin-top: 0%;
    margin-bottom: 50%;
    width: 400px;
  } 
}

@media only screen and (max-width: 500px) {
  .testimoni {
    margin-top: -20%;
    margin-bottom: 10%;
    width: 400px;
  } 
  .txt-apa {
    margin-left: -35%;
  }
  .txt-testi {
    margin-top: 15%;
    margin-left: -45%;
    width: 180px;
    font-size: 124x;
    font-size: 12px;
  }
  .txt-view {
    font-size: 12px;
    margin-left: -45%;
  }
  .container {
    margin-top: -15%;
  }
  .testimoni Splide {
    flex-direction: column;
  }
}

</style>
